<form [formGroup]="insuranceForm" (ngSubmit)="saveInsurance(inProgress)">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="bx bx-donate-heart me-1 font-20 text-primary"></i>{{insuranceForm.value.id?'Update':'Add'}} Insurance
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-3">
        <label for="name" class="form-label">Name <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-id-card'></i></span>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter the name"
            [ngClass]="{'is-invalid': submitted && i.controls.name?.errors}" formControlName="name" ngbAutofocus
            autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback" *ngIf="submitted && i.controls.name?.errors">
            <span *ngIf="i.controls.name?.errors.required">Please provide a valid name.</span>
            <span *ngIf="i.controls.name?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="registrationNumber" class="form-label">Registration Number <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-id-card'></i></span>
          <input type="text" class="form-control ps-1" id="registrationNumber" placeholder="Enter Registration Number"
            [ngClass]="{'is-invalid': submitted && i.controls.registrationNumber?.errors}"
            formControlName="registrationNumber" autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback" *ngIf="submitted && i.controls.registrationNumber?.errors">
            <span *ngIf="i.controls.registrationNumber?.errors.required">Please provide a valid Registration
              Number.</span>
            <span *ngIf="i.controls.registrationNumber?.errors.pattern">Enter the valid Registration Number.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="established" class="form-label">
          Established Year <b class="text-secondary">*</b>
        </label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="bx bx-calendar"></i>
          </span>
          <ng-select class="form-control rcx-ng-select" formControlName="established" [placeholder]="truncatedPlaceholder" [disabled]="!insuranceStatus"
          [ngClass]="{'is-invalid': submitted && i.controls.established.errors}"  [clearable]="true" [searchable]="true">
          <ng-option *ngFor=" let year of years;" [value]="year">{{year}}</ng-option>
        </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && i.controls.established.errors">
            <span *ngIf="i.controls.established.errors.required">
              Please select a valid established year.
            </span>
            <span *ngIf="i.controls.established.errors.pattern">Enter the valid year.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="licenceNumber" class="form-label">Licence Number <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-id-card'></i></span>
          <input type="text" class="form-control ps-1" id="licenceNumber" placeholder="Enter the Licence Number"
            [ngClass]="{'is-invalid': submitted && i.controls.licenceNumber.errors}" formControlName="licenceNumber"
            autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback" *ngIf="submitted && i.controls.licenceNumber.errors">
            <span *ngIf="i.controls.licenceNumber.errors.required">Please provide a valid Licence Number.</span>
            <span *ngIf="i.controls.licenceNumber.errors.pattern">Enter the valid licence number.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="pan" class="form-label">Pan</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bxs-id-card'></i></span>
          <input type="text" class="form-control ps-1" id="pan" placeholder="Enter your pan number"
            [ngClass]="{'is-invalid': submitted && i.controls.pan.errors}" formControlName="pan" autocomplete="off"
            [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback" *ngIf="submitted && i.controls.pan.errors">
            <span *ngIf="i.controls.pan.errors.required">Please provide a valid Pan Number.</span>
            <span *ngIf="i.controls.pan.errors.pattern">Enter the valid Pan Number.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="gstIn" class="form-label">GSTIN</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-id-card'></i></span>
          <input type="text" class="form-control ps-1" id="gstIn" placeholder="Enter the GSTIN number"
            [ngClass]="{'is-invalid': submitted && i.controls.gstIn.errors}" formControlName="gstIn" autocomplete="off"
            [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback" *ngIf="submitted && i.controls.gstIn.errors">
            <span *ngIf="i.controls.gstIn.errors.required">Please provide a valid GSTIN number.</span>
            <span *ngIf="i.controls.gstIn.errors.pattern">Enter the valid GST number.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="email" class="form-label">Email</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-envelope'></i></span>
          <input type="text" class="form-control ps-1" id="email" placeholder="Enter the email"
            [ngClass]="{'is-invalid': submitted && i.controls.email.errors}" formControlName="email" autocomplete="off"
            [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback" *ngIf="submitted && i.controls.email.errors">
            <span *ngIf="i.controls.email.errors.required">Please provide a valid email.</span>
            <span *ngIf="i.controls.email.errors.pattern">Please provide a valid email address.</span>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <label for="label" class="form-label">Tag</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bxs-purchase-tag'></i></span>
          <input type="text" class="form-control ps-1" id="label" placeholder="Enter the tag"
            [ngClass]="{'is-invalid': submitted && i.controls.label.errors}" formControlName="label" autocomplete="off"
            [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback" *ngIf="submitted && i.controls.label.errors">
            <span *ngIf="i.controls.label.errors.required">Please provide the label.</span>
            <span *ngIf="i.controls.label.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="Logo" class="form-label">Logo</label>
        <div class="input-group">
          <input type="file" class="custom-file-input form-control" id="upload" (change)="getAndSetBase64($event)"
            accept=".jpg,.jpeg,.png" formControlName="logo">
        </div>
      </div>
      <div class="col-md-3">
        <label for="contact" class="form-label">Contact</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bxs-contact'></i></span>
          <input type="text" class="form-control ps-1" id="contact" placeholder="Enter the contact number"
            [ngClass]="{'is-invalid': submitted && i.controls.contact.errors}" formControlName="contact"
            autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback" *ngIf="submitted && i.controls.contact.errors">
            <span *ngIf="i.controls.contact.errors.required">Please provide a valid contact.</span>
            <span *ngIf="i.controls.contact.errors.pattern">Only numbers are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="website" class="form-label">Website</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-globe'></i></span>
          <input type="text" class="form-control ps-1" id="website" placeholder="Enter the website"
            [ngClass]="{'is-invalid': submitted && i.controls.website.errors}" formControlName="website"
            autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback" *ngIf="submitted && i.controls.website.errors">
            <span *ngIf="i.controls.website.errors.required">Please provide a valid website.</span>
            <span *ngIf="i.controls.website.errors.pattern">Please provide the valid website.</span>
          </div>
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
          <label class="form-check-label" for="disabled">Disabled</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}"
      [disabled]="insuranceStatus==false">
      <ng-container *ngIf="inProgress?.value=='true'">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{insuranceForm.value.id?'Updating...':'Saving...'}}
      </ng-container>
      <ng-container *ngIf="inProgress?.value!='true'">
        <i class="bx bx-save"></i>{{insuranceForm.value.id?'Save Changes':'Save'}}
      </ng-container>
    </button>
  </div>
</form>
<div *ngIf="insuranceForm.value.id">
  <app-address [refId]="insuranceForm?.value?.id" ref="INSURER" [onLoad]="onLoad"
    [ngClass]="{ 'grayed-out': insuranceStatus==false }"></app-address>
</div>
<form [formGroup]="insurancePlanForm" (ngSubmit)="saveInsurancePlan(inProgress)" *ngIf="insuranceForm?.value?.id"
  class="form-row">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="bx bx-calendar me-1 font-20 text-primary"></i>{{insurancePlanForm?.value.id?'Update':'Add'}} Insurance
      Plan
    </h5>
  </div>
  <div class="modal-body" formArrayName="insurancePlans">
    <div class="row g-3 insurance-plan-row" *ngFor="let insurancePlan of insurancePlans.controls; let i=index"
      [formGroupName]="i">
      <div class="col-md-3">
        <label for="name" class="form-label">Name <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-id-card'></i></span>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter name"
            [ngClass]="{'is-invalid':insurancePlan.get('name')?.touched && insurancePlan.get('name')?.errors}"
            formControlName="name" autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback"
            *ngIf="insurancePlan.get('name')?.touched  && insurancePlan.get('name')?.errors">
            <span *ngIf="insurancePlan.get('name')?.errors.required">Please provide a valid
              name.</span>
            <span *ngIf="insurancePlan.get('name')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="type" class="form-label">Insurance Type <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-health'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="type" placeholder="Select insurance type"
            [ngClass]="{'is-invalid': insurancePlan.get('type')?.touched && insurancePlan.get('type')?.errors}"
            [clearable]="false" [readonly]="insuranceStatus==false">
            <ng-option *ngFor="let type of types" [value]="type">{{type}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="insurancePlan.get('type')?.touched && insurancePlan.get('type')?.errors">
            <span *ngIf="insurancePlan.get('type')?.errors.required">Please select an insurance type.</span>
            <span *ngIf="insurancePlan.get('type')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="premium" class="form-label">Premium <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-captions'></i></span>
          <input type="text" class="form-control ps-1" id="premium" placeholder="Enter premium"
            [ngClass]="{'is-invalid':insurancePlan.get('premium')?.touched && insurancePlan.get('premium')?.errors}"
            formControlName="premium" autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback"
            *ngIf="insurancePlan.get('premium')?.touched  && insurancePlan.get('premium')?.errors">
            <span *ngIf="insurancePlan.get('premium')?.errors.required">Please provide a valid
              premium.</span>
            <span *ngIf="insurancePlan.get('premium')?.errors.pattern">Only numbers are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="coverage" class="form-label">Coverage <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-captions'></i></span>
          <input type="text" class="form-control ps-1" id="coverage" placeholder="Enter coverage"   (blur)="formatCoverage($event)"
          [value]="insurancePlanForm.get('coverage')?.value | number: '1.0-0'"
            [ngClass]="{'is-invalid':insurancePlan.get('coverage')?.touched && insurancePlan.get('coverage')?.errors}"
            formControlName="coverage" autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback"
            *ngIf="insurancePlan.get('coverage')?.touched  && insurancePlan.get('coverage')?.errors">
            <span *ngIf="insurancePlan.get('coverage')?.errors.required">Please provide a valid
              coverage.</span>
            <span *ngIf="insurancePlan.get('coverage')?.errors.pattern">Only numbers are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="tenure" class="form-label">Tenure(in M) <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-calendar'></i></span>
          <input type="text" class="form-control ps-1" id="tenure" placeholder="Enter tenure"
            [ngClass]="{'is-invalid':insurancePlan.get('tenure')?.touched && insurancePlan.get('tenure')?.errors}"
            formControlName="tenure" autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback"
            *ngIf="insurancePlan.get('tenure')?.touched  && insurancePlan.get('tenure')?.errors">
            <span *ngIf="insurancePlan.get('tenure')?.errors.required">Please provide a valid
              tenure.</span>
            <span *ngIf="insurancePlan.get('tenure')?.errors.pattern">Please provide a valid tenure </span>
            <span *ngIf="insurancePlan.get('tenure')?.errors.min || insurancePlan.get('tenure')?.errors.max">
              Please enter a tenure between 1 and 12 months.
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="features" class="form-label">Features <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-calendar'></i></span>
          <input type="text" class="form-control ps-1" id="features" placeholder="Enter features"
            [ngClass]="{'is-invalid':insurancePlan.get('features')?.touched && insurancePlan.get('features')?.errors}"
            formControlName="features" autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback"
            *ngIf="insurancePlan.get('features')?.touched  && insurancePlan.get('features')?.errors">
            <span *ngIf="insurancePlan.get('features')?.errors.required">Please provide a valid
              features.</span>
            <span *ngIf="insurancePlan.get('features')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="agreement" class="form-label">Agreement <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-credit-card-front'></i></span>
          <input type="text" class="form-control ps-1" id="agreement" placeholder="Enter agreement"
            [ngClass]="{'is-invalid':insurancePlan.get('agreement')?.touched && insurancePlan.get('agreement')?.errors}"
            formControlName="agreement" autocomplete="off" [readOnly]="insuranceStatus==false" />
          <div class="invalid-feedback"
            *ngIf="insurancePlan.get('agreement')?.touched  && insurancePlan.get('agreement')?.errors">
            <span *ngIf="insurancePlan.get('agreement')?.errors.required">Please provide a valid
              agreement.</span>
            <span *ngIf="insurancePlan.get('agreement')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="active" formControlName="active"
            [disabled]="insuranceStatus==false">
          <label class="form-check-label" for="active">Active</label>
        </div>
      </div>
      <div class="col-md-auto mt-5 ms-auto me-0">
        <button type="submit" title="add insurance plan" *ngIf="i === insurancePlans.length - 1"
          (click)="addInsurancePlan(InsurancePlan, i)" class="btn btn-secondary btn-sm me-2"
          [disabled]="insuranceStatus==false"><i class='bx bx-plus'></i> Add plan
        </button>
        <button type="button" class="btn btn-danger btn-sm" (click)="deleteInsurancePlan(i, insurancePlan)"
          [disabled]="insuranceStatus==false"><i class='bx bx-trash'></i>Delete
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}"
      [disabled]="insuranceStatus==false">
      <ng-container *ngIf="inProgress?.value=='true'" [readOnly]="insuranceStatus==false">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{insurancePlanForm?.value.id?'Updating...':'Saving...'}}
      </ng-container>
      <ng-container *ngIf="inProgress?.value!='true'">
        <i class="bx bx-save"></i>{{insurancePlanForm?.value.id?'Save Changes':'Save'}}
      </ng-container>
    </button>
  </div>
</form>